<template>
    <div id="about">
        <div class="more">
            <!-- <Titulos :titu="'HELLO'"></Titulos> -->
            <!-- <img class="mapa" src="@/assets/img/mapa.png" alt="mapa"> -->
            <!-- <video v-if="mobile" autoplay loop muted>
            <source :src="require('@/assets/img/vid/aboutMob.mp4')" type="video/mp4">
            Your browser does not support the video tag.</video>
            <video v-else autoplay loop muted>
            <source :src="require('@/assets/img/vid/about.mp4')" type="video/mp4">
            Your browser does not support the video tag.</video>
            <div id="desc"> -->
                <!-- <p class="hi">HELLO</p> -->
                <!-- <p>Hello, I'm Nicolás, visual designer living and working in Buenos Aires, Argentina.</p> -->
                <!-- <p>I graduated from University of Buenos Aires (UBA) as Graphic Designer.</p> -->
                <!-- <p>I've worked as graphic designer and front-end developer at several design studios and media companies.</p>
                <p>I specialize in UI design, interactive infographics and illustration.</p> -->
                <!-- <p> Former infographic designer at <a href="https://www.lanacion.com.ar" target="_blank">lanacion.com.ar</a></p> -->
                <!-- <p>Currently working as freelancer, I'm always interested in new projects. If you have any questions or want to discuss an idea, send me an email to <a href="mailto:hello@nicolasrivera.com.ar" class="mailHello">hello@nicolasrivera.com.ar</a></p>
                <p>❤️ 🐈 ⚽ <span>🚲</span></p>
            </div> -->
            <!-- <img src="https://www.nicolasrivera.com.ar/img/hola.png" alt=""> -->
            <section class="hero">
                <div class="heroText">
                    <!-- <h5>Frontend Developer</h5>
                    <h4>Graphic Designer</h4>
                    <h1>Nicolás Rivera</h1>
                    <p>Texto que me describa</p> -->
                    <!-- <p class="hi">HELLO</p> -->
                    <p>You can call me <strong>Nico</strong>, I'm visual designer living in and working from Buenos Aires, Argentina.</p>
                    <p>I graduated from <strong>University of Buenos Aires</strong> as Graphic Designer.</p>
                    <p>I've worked as graphic designer and front-end developer at several design studios and media companies.</p>
                    <!-- <a href="#">CV</a> -->
                    <!-- <a href="#" class="videos"><i class="ri-play-fill"></i>Mirá mis videos</a> -->
                </div>
                <div class="heroImg">
                    <video autoplay loop muted>
                    <source :src="require('@/assets/img/vid/aboutMob.mp4')" type="video/mp4">
                    Your browser does not support the video tag.></video>
                </div>
                <div class="heroText">
                    <p><strong>I specialize in UI design, interactive infographics and illustration.</strong></p>
                    <!-- <p> Former infographic designer at <a href="https://www.lanacion.com.ar" target="_blank">lanacion.com.ar</a></p> -->
                    <p>Currently working as freelancer, I'm always interested in new projects. If you have any questions or want to discuss an idea, send me an email to:<br><a href="mailto:hello@nicolasrivera.com.ar" class="mailHello">hello@nicolasrivera.com.ar</a></p>
                    <p><span>❤️ </span><span>🐈 </span> <span>⚽ </span><span class="bici">🚴🏻</span></p>
                </div>
            </section>
            <div class="icons">
                <a href="#"><i class="ri-instagram-line"></i></a>
                <a href="#"><i class="ri-github-fill"></i></a>
                <a href="#"><i class="ri-twitter-x-line"></i></a>
                <a href="#"><i class="ri-behance-line"></i></a>
            </div>
            <!-- <div class="scrollDown">
                <a href="#head">^</a>
            </div> -->
        </div>
        <!-- <div id="holas">
            <p class="hola" v-for="(hola, index) in holas" :key="index" :class="{bo: index % 2 === 0}">{{ hola }}</p>
        </div> -->
    </div>
</template>

<script>
// import Titulos from './Titulos.vue'

export default {
    // components: {
    //     Titulos
    // },
    props: {
        mobile: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            // holas: [ 'Hello', 'Përshëndetje', 'እው ሰላም ነው', 'Hola', 'Hallo', 'مرحبًا', 'Barev', 'Salam', 'Guten tag', 'Kaixo', 'হ্যালো', 'Zdravo', 'Hola', 'Здравейте', 'ဟယ်လို', '你好', 'Kamusta', 'Zdravo', 'Ahoj', 'Hej', 'Hallo', 'Hello', 'Tere', 'سلام', 'Bula', 'Hei', 'Bonjour', 'Dia dhuit', 'გამარჯობა', 'γεια', 'Bonjou', 'Aloha', 'שלום', 'नमस्ते', 'Nyob zoo', 'Szia', 'Halló', 'Ndewo', 'Halo', 'Ciao', 'こんにちは', 'សួស្តី', '안녕하세요', 'Slav', 'ສະບາຍດີ', 'Sveika', 'Sveiks' ]
            holas: [ 'Hello', 'Hola', 'Hallo', 'مرحبًا', 'Barev', 'Salam', 'Guten tag', 'Kaixo', 'হ্যালো', 'Zdravo', 'Hola', 'Здравейте', 'ဟယ်လို', '你好', 'Kamusta', 'Zdravo', 'Ahoj', 'Hej', 'Hallo', 'Përshëndetje', 'እው ሰላም ነው', 'Tere', 'سلام', 'Bula', 'Hei', 'Bonjour', 'Dia dhuit', 'გამარჯობა', 'γεια', 'Bonjou', 'Aloha', 'שלום', 'नमस्ते', 'Nyob zoo', 'Szia', 'Halló', 'Ndewo', 'Halo', 'Ciao', 'こんにちは', 'សួស្តី', '안녕하세요', 'Slav', 'ສະບາຍດີ', 'Sveika', 'Sveiks', 'Sveiki', 'Moien', 'Salama', 'Selamat pagi', 'Bongu', '你好', 'नमस्कार', 'сайн уу', 'Niltze Tialli Pialli', 'Ya’at’eeh', 'नमस्कार', 'Hei', 'سلام', 'Cześć', 'Olá', 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ', 'Allianchu', 'Bunâ', 'Привет', 'Talofa', 'Dumela', 'Ahoj', 'Zdravo', 'Hola', 'Jambo', 'Hallå', 'Kamusta', 'Ia Orana', 'Li-hó', 'வணக்கம்', 'สวัสดี', 'Tashi delek', 'Mālō e lelei', 'Merhaba', 'привіт', 'السلام عليكم', 'Salom', 'Xin chào', 'Molo', 'Hello', 'Përshëndetje', 'እው ሰላም ነው', 'Hola', 'Hallo', 'مرحبًا' ]
            // holas: [ '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲', '❤️ 🐈 ⚽ 🚲' ]
        }
    }
}
</script>

<style scoped lang="scss"> 
#about{
    position: relative;
    height: 120vh;

    .more{
        width: 100%;
        margin: auto;
        height: 120vh;
        align-items: center;
        display: flex;
        visibility: visible;

        section{
            padding: 0 8%;
            background-image: url('https://www.nicolasrivera.com.ar/img/hola.png');
            background-position: left 50px;
            background-size: 50%;
            background-repeat: repeat-x;
            // mix-blend-mode: difference;
        }
        .hero{
            mix-blend-mode: difference;
            width: 95%;
            height: 100%;
            max-height: 90vh;
            // background: linear-gradient(245.59deg, #31494e 0%, #385e70 25%, #131313 75%);
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            // align-items: center;
            // gap: 2rem;
            margin: 180px auto auto;
            
            .heroText {
                color: white;
                align-self: flex-start;
                font-weight: 200;
                font-size: 1.1rem;

                span{
                    margin: auto 15px auto 0;
                }
                .bici{
                    font-size: 22px;
                }
                
                p {
                    width: 100%;
                    margin: 10px auto;
                    margin-bottom: 20px;
                    line-height: 1.7;
                }
                .mailHello{
                    display: inline-block;
                    background-color: transparent;
                    border: 1px solid transparent;
                    padding: 5px 10px 5px 5px;
                    line-height: 1.4;
                    font-size: 15px;
                    font-weight: 500;
                    // border-radius: 30px;
                    text-transform: uppercase;
                    transition: all .5s ease;
                    color: aqua;
                    text-decoration: none;
                    letter-spacing: 1px;
                    &:hover{
                        background-color: var(--white);
                        color: var(--black);
                        // border: 1px solid var(--white);
                        transform: translateX(10px);
                    }
                    &.videos{
                        background-color: transparent;
                        border: 1px solid var(--white);
                        margin-left: 20px;
                        i{
                            vertical-align: middle;
                            margin-right: 5px;
                        }
                    }
                }
            }
            
            .heroImg {
                justify-self: center;
                align-self: flex-start;
                width: 85%;
                margin: 0px auto;
                
                video{
                    width: 100%;
                    margin: 0px auto;
                    height: auto;
                    transition: all .3s linear;
                    border-radius: 50%;
                    &:hover{
                        width: 330px;
                        opacity: 0.8;
                    }
                }
            }
        }
        .icons{
            position: absolute;
            top: 50vh;
            padding: 0 2%;
            transform: translateY(-50%);
            i{
                display: block;
                margin: 26px 0;
                font-size: 24px;
                transition: all .3s ease;
                &:hover{
                    color: #4d4d4d;
                    transform: translateY(-5px);
                }
            }
        }
        .scrollDown{
            position: fixed;
            bottom: 6%;
            right: 4%;
            a{
                background-color: var(--black);
                // width: 30px;
                // height: 30px;
                border-radius: 30px;
                padding: 10px 15px;
                font-size: 23px;
                line-height: 23px;
                vertical-align: bottom;
                // display: block;
                color: var(--white);
                text-decoration: none;
                font-family:Verdana, Geneva, Tahoma, sans-serif;
                transition: all .5s ease;
                cursor: pointer;
                &:hover{
                    transform: translateY(-7px);
                    background-color: aqua;
                    color: var(--black);
                    // mix-blend-mode: difference;
                }
            }
        }
    }
    /*#holas{
        width: 100%;
        height: 100px;
        align-items: center;
        display: flex;
        position: absolute;
        top: 40vh;
        // left: 0%;
        // transform: translateY(-50%);
        // left: var(--x, 0px);
        animation: move 100s linear infinite;
        z-index: 0;
        .hola{
            flex: none;
            display: flex;
            font-family: var(--roboto);
            font-weight: 100;
            font-size: 8rem;
            margin: 0 50px;
            opacity: 0.1;
            white-space: nowrap;

            @media screen and (max-width: 600px){
                font-size: 4rem;
            }

            &.bo{
                font-family: serif;
                font-style: normal;
                // font-weight: 800;
                // opacity: .6;
            }
        }
    }*/
    @keyframes move {
        0% {
            // transform: translateX(0px);
            left: 0%;
        }
        100% {
            left: -25000px;
            // transform: translateX(calc(var(--x, 0px) - 22050px ));
            // transform: translateX(-25000px);
        }
    }
}

@media screen and (max-width: 900px){
    #about{
        .more{
            section{
                background-position: center top;
                background-size: 50%;
                background-repeat: repeat-y;
                // mix-blend-mode: difference;
            }
            .hero{
                grid-template-columns: 1fr;
                grid-template-rows: 1fr 1fr 1fr;
                height: 120vh;
                width: 100%;
                max-height: 120vh;
                margin: 180px auto 50px;

                .heroText {
                    font-size: 1rem;

                    p {
                        margin-bottom: 10px;
                        line-height: 1.5;
                    }
                }

                .heroImg {
                    width: 50%;
                    align-self: center;
                    video{
                        width: 80%;
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 780px){
    #about{
        .more{
            height: 90vh;
            .hero{
                height: 90vh;
                max-height: 90vh;
                margin: 100px auto 50px;
            }
        }
    }
}
@media screen and (max-width: 600px){
    #about{
        padding-top: 85px;
        margin-bottom: 100px;

        .more{
            width: 100%;
            flex-direction: column;

            section{
                background-size: 80%;
            }
            .hero{
                margin: 30px auto 50px;
                .heroImg {
                    width: 85%;
                }
            }
        }
    }
}
</style>